import { TreeSelect } from 'antd';
import { useState } from 'react';
import { t } from 'i18next';
import PropTypes from 'prop-types';

export default function TrrSelectCustom({
    onChange,
    value,
    department,
    disabled,
}) {
    const [selectedValues, setSelectedValues] = useState(value ?? []);
    const values = department?.map((x) => {
        return {
            title: x.nameEn,
            value: x.departmentId,
        };
    });

    const allIds = values.map(({ value }) => value);
    const triggerChange = (changedValue) => {
        onChange?.(changedValue);
    };

    return (
        <TreeSelect
            disabled={disabled}
            treeCheckable
            size="large"
            value={selectedValues}
            filterTreeNode={(search, item) => {
                return (
                    String(item?.title)
                        ?.toLowerCase()
                        ?.indexOf(search?.toLowerCase()) >= 0
                );
            }}
            showCheckedStrategy={TreeSelect.SHOW_CHILD}
            dropdownStyle={{ maxHeight: '300px' }}
            onChange={(ids) => {
                setSelectedValues(ids);
                triggerChange(ids);
            }}
            placeholder={t('dataFlow.SelectDepartment')}
            treeData={[
                {
                    title:
                        selectedValues.length === values.length ? (
                            <button
                                type="button"
                                onClick={() => {
                                    setSelectedValues([]);
                                    triggerChange([]);
                                }}
                                style={{
                                    display: 'inline-block',
                                    color: '#286FBE',
                                    cursor: 'pointer',
                                }}
                            >
                                {t('dataFlow.UnselectAll')}
                            </button>
                        ) : (
                            <button
                                type="button"
                                onClick={() => {
                                    setSelectedValues(allIds);
                                    triggerChange(allIds);
                                }}
                                style={{
                                    display: 'inline-block',
                                    color: '#286FBE',
                                    cursor: 'pointer',
                                }}
                            >
                                {t('RoPA.SelectAll')}
                            </button>
                        ),
                    value: 'xxx',
                    disableCheckbox: true,
                    disabled: true,
                    checkable: false,
                },
                ...values,
            ]}
        />
    );
}

TrrSelectCustom.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.array,
    department: PropTypes.array,
    disabled: PropTypes.bool,
};
